const NAME = "POLL";

export default NAME;
